import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex items-start justify-between gap-4 max-[640px]:flex-col max-[640px]:items-stretch" }
const _hoisted_2 = {
  key: 0,
  class: "space-y-3 p-6"
}
const _hoisted_3 = {
  key: 1,
  class: "px-6 py-6"
}
const _hoisted_4 = {
  key: 2,
  class: "max-h-[520px] space-y-0 overflow-y-auto px-6 pb-2"
}
const _hoisted_5 = { class: "min-w-0 flex-1" }
const _hoisted_6 = { class: "flex flex-col gap-1 sm:flex-row sm:items-center sm:justify-between" }
const _hoisted_7 = { class: "font-semibold text-[#182033]" }
const _hoisted_8 = { class: "text-[0.8rem] text-[#8a95a9]" }
const _hoisted_9 = { class: "mt-1 text-[0.92rem] leading-6 text-[#6e7b92]" }
const _hoisted_10 = { class: "mt-2 flex flex-wrap items-center gap-2" }
const _hoisted_11 = {
  key: 0,
  class: "text-[0.82rem] text-[#6e7b92]"
}

import { computed } from "vue";
import {
  ArrowRightLeft,
  FileText,
  MessageSquarePlus,
  Ticket,
  UserPlus,
  CalendarClock,
} from "lucide-vue-next";
import { Badge } from "@/components/ui/badge";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";
import type { DashboardActivityItem, DashboardRole } from "@/types/dashboard";


export default /*@__PURE__*/_defineComponent({
  __name: 'RecentActivityList',
  props: {
    data: {},
    loading: { type: Boolean },
    role: {}
  },
  setup(__props: any) {

const props = __props;

const showClientName = computed(() => props.role !== "client");

function formatDate(value: string) {
  return new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(value));
}

function readableType(type: string) {
  return type.replace(/_/g, " ").replace(/\b\w/g, (m) => m.toUpperCase());
}

function iconForType(type: string) {
  const key = type.toLowerCase();
  if (key.includes("task_created")) return UserPlus;
  if (key.includes("task_updated")) return ArrowRightLeft;
  if (key.includes("status")) return FileText;
  if (key.includes("ticket")) return Ticket;
  if (key.includes("report")) return FileText;
  if (key.includes("lead")) return MessageSquarePlus;
  return CalendarClock;
}

function iconShellClass(type: string) {
  const key = type.toLowerCase();
  if (key.includes("report")) return "bg-[#f2ebff]";
  if (key.includes("ticket")) return "bg-[#fff3e3]";
  if (key.includes("lead")) return "bg-[#e8f1ff]";
  if (key.includes("task_created")) return "bg-[#e6f8ec]";
  if (key.includes("task_updated")) return "bg-[#edf4ff]";
  return "bg-[#f1f5fb]";
}

function iconColorClass(type: string) {
  const key = type.toLowerCase();
  if (key.includes("report")) return "text-[#7c3aed]";
  if (key.includes("ticket")) return "text-[#b45309]";
  if (key.includes("lead")) return "text-[#2855a6]";
  if (key.includes("task_created")) return "text-[#15803d]";
  if (key.includes("task_updated")) return "text-[#2563eb]";
  return "text-[#6e7b92]";
}

function badgeClass(type: string) {
  const key = type.toLowerCase();
  if (key.includes("report")) return "bg-[#f2ebff] text-[#7c3aed]";
  if (key.includes("ticket")) return "bg-[#fff0cf] text-[#b45309]";
  if (key.includes("lead")) return "bg-[#e8f1ff] text-[#2855a6]";
  if (key.includes("task_created")) return "bg-[#e6f8ec] text-[#15803d]";
  if (key.includes("task_updated")) return "bg-[#edf4ff] text-[#2563eb]";
  return "bg-[#f1f5fb] text-[#64748b]";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Card), {
    "data-pdf-exclude": "true",
    class: "flex h-full min-w-0 w-full flex-col overflow-hidden rounded-[1.35rem] border border-[rgba(218,226,238,0.95)] bg-gradient-to-b from-white to-[#fbfcff] shadow-[0_20px_40px_rgba(15,23,42,0.05)]"
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(CardHeader), { class: "border-b border-[rgba(227,233,243,0.95)] px-6 py-5 pb-4" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", null, [
              _createVNode(_unref(CardTitle), { class: "m-0 text-[1.2rem] font-extrabold text-[#182033]" }, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode(" Recent Activity ", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_unref(CardDescription), { class: "mt-[0.35rem] text-[#6e7b92]" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.role === 'client' ? 'Latest updates across your tasks, tickets, reports, and services.' : 'Latest task, ticket, and report activity.'), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(CardContent), { class: "flex-1 p-0" }, {
        default: _withCtx(() => [
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
                  return _createVNode(_unref(Skeleton), {
                    key: n,
                    class: "h-[4.75rem] rounded-[1.15rem] bg-stone-100"
                  })
                }), 64))
              ]))
            : (!__props.data.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[1] || (_cache[1] = [
                  _createElementVNode("div", { class: "grid min-h-[16rem] place-items-center rounded-[1.15rem] border border-dashed border-[rgba(218,226,238,0.95)] bg-[#fbfcff] px-6 text-center" }, [
                    _createElementVNode("div", { class: "max-w-md" }, [
                      _createElementVNode("p", { class: "text-[1rem] font-bold text-[#182033]" }, " No activity yet "),
                      _createElementVNode("p", { class: "mt-2 text-[0.92rem] leading-7 text-[#6e7b92]" }, " Activity will appear once tasks, tickets, or reports are created. ")
                    ])
                  ], -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.data, (item) => {
                    return (_openBlock(), _createElementBlock("article", {
                      key: item.id,
                      class: "flex items-start gap-3 border-t border-[rgba(235,240,247,1)] py-4 first:border-t-0"
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["mt-1 flex size-10 shrink-0 items-center justify-center rounded-[0.95rem]", iconShellClass(item.type)])
                      }, [
                        (_openBlock(), _createBlock(_resolveDynamicComponent(iconForType(item.type)), {
                          class: _normalizeClass(["size-5", iconColorClass(item.type)])
                        }, null, 8, ["class"]))
                      ], 2),
                      _createElementVNode("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("p", _hoisted_7, _toDisplayString(item.title), 1),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(formatDate(item.created_at)), 1)
                        ]),
                        _createElementVNode("p", _hoisted_9, _toDisplayString(item.description), 1),
                        _createElementVNode("div", _hoisted_10, [
                          _createVNode(_unref(Badge), {
                            variant: "outline",
                            class: _normalizeClass(["rounded-full px-3 py-[0.35rem] text-[0.76rem] font-extrabold", badgeClass(item.type)])
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(readableType(item.type)), 1)
                            ]),
                            _: 2
                          }, 1032, ["class"]),
                          (showClientName.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.client_name), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]))
                  }), 128))
                ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})